export default __webpack_public_path__ + "static/media/sc-bi-ico.bd785e72.svg";